export const DIAGRAM_IMPORT_BUBBLE_TYPES = [
  'runout',
  'diameter',
  'visual',
  'generic',
  'length',
];

export const DIAGRAM_SPREADSHEET_IMPORT_TYPES = [
  ...DIAGRAM_IMPORT_BUBBLE_TYPES,
  'aligned length',
];

export const DIAGRAM_EXPORT_HEADERS = [
  'Label',
  'Bubble Type',
  'Description',
  'Unit',
  'Expected Value',
  'Tolerance 1',
  'Tolerance 2',
  'Positions',
  'Orientation',
];

export const EMPTY_VISUAL_MEASUREMENT_VALUE = {
  value: 'notCompleted',
  images: [],
  comment: '',
};
